<script>
export default {
    name: "NumericEnumRelation",
    data() {
        return {
            attributesRelations: [],
            numericAttributes: [],
            numericEnum: {},
        }
    },
    methods: {
        getDefaultNumericEnum() {
            return {
                attributeID: null,
                attributeName: null,
                valueID: null,
                valueName: null,
                value: null,
                unitID: null,
                units: []
            }
        },
        checkRelation(enumID) {
            if(this.attributesRelations.indexOf(enumID) < 0)
                return false;

            const enumAttribute = this.enumAttributes[enumID];

            if(!enumAttribute || !enumAttribute.length)
                return this.resetRelation(enumID);

            this.updateNumericEnum(enumAttribute, enumID);
        },
        resetRelation(enumID) {
            if(this.numericEnum[enumID])
                delete this.numericEnum[enumID];
        },
        updateNumericEnum(attributeValues, enumID) {
            if (!this.numericEnum[enumID])
                this.numericEnum[enumID] = [];

            const numericEnum = [];
            const numericAttributeInitial = this.productAttributes.numeric.find(item => item.enumID === enumID);

            attributeValues.forEach(item => {
                let numericAttribute = this.numericEnum[enumID].find(attr => attr.valueID === item.id);

                if(!numericAttribute) {
                    numericAttribute = this.getDefaultNumericEnum()
                    numericAttribute.valueName = item.name;
                    numericAttribute.valueID = item.id;
                    numericAttribute.attributeID = numericAttributeInitial.id;
                    numericAttribute.attributeName = numericAttributeInitial.name;
                    numericAttribute.units = numericAttributeInitial.units;
                }

                numericEnum.push(numericAttribute);
            });

            this.numericEnum[enumID] = numericEnum;
        },
        setRelations() {
            this.numericEnum = {};

            if(!this.productAttributes.numeric || !this.productAttributes.numeric.length) {
                this.attributesRelations = [];
                return false;
            }

            this.attributesRelations = this.productAttributes.numeric.map(item => {
                return item.enumID;
            });
        }
    },
    watch: {
        productAttributes: {
            handler() {
                this.setRelations();
            },
            deep: true
        }
    }

}
</script>

<style scoped>

</style>
